import Image1 from '../assets/community/comments-1.webp'
import Image2 from '../assets/community/comments-2.webp'
import Image3 from '../assets/community/comments-3.webp'
import Image4 from '../assets/community/comments-4.webp'

const CARDS = [
  {
    title: 'Paola Castillo',
    description: 'En Vida, encontré un espacio donde la colaboración y el acompañamiento auténtico hicieron florecer cada encuentro. Junto a Pili y Trini, sostuvimos un taller con amor, confianza y cuidado, creando un verdadero hogar para la conciencia.',
    job: 'Terapia Gestalt y Medicina Energética',
    image: Image1
  }, {
    title: 'Piero Graziani',
    description: 'VIDA es la comunidad de los trabajadores remotos, me hacen sentir parte, arman actividades, me ayuda a concentrarme, distenderme y disfrutar de los días laborales.',
    job: 'Account Executive',
    image: Image2
  }, {
    title: 'Juli Benassi',
    description: 'Tuve la oportunidad de ser disertante y organizar mis talleres en Vida, la verdad es que no solamente el lugar es precioso y cuenta con todas las herramientas y elementos que necesitás para poder estar allí cómoda, no tenés que pensar en nada cuando vas sino que la gestión de todo el equipo de Vida es super productiva y eficaz y amorosa. Ha sido un placer ser parte.',
    job: 'Astróloga, Tarotista, Terapeuta Floral y Tameana',
    image: Image3
  }, {
    title: 'Negro Monteiro',
    description: 'Hago mis eventos en Vida por que es un espacio de amor y alegría, la gente es divina y la estética es muy inspiradora.',
    job: 'Comunicador y Founder de Club de Líderes Conscientes y Club de Los Milagros',
    image: Image4
  }
]

const CommunityCards = () => {
  return (
    <div className="CommunityCards container-custom">
      {CARDS.map((card, index) => (
        <div
          key={`Community-Card-${index}`}
          className="CommunityCards__Card"
        >
          <div className='d-flex flex-column gap-2'>
            <img
              className='CommunityCards__Card-Image'
              src={card.image}
              alt={card.title}
              title={card.title}
            />

            <p className="text-5 text-gray-dark">
              { card.description }
            </p>
          </div>

          <div className="d-flex flex-column gap-1">
            <h3 className="CommunityCards__Card-Title text-uppercase">
              { card.title }
            </h3>
            <p className="CommunityCards__Card-Job text-gray-dark">
              { card.job }
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CommunityCards